<template>
    <el-drawer
        size="65%"
        :with-header="false"
        :visible.sync="visible">

      <div style="padding: 15px;" >
        <el-alert
          title="说明"
          type="info"
          show-icon v-if="config.includeMall && !config.freeCourse" >
          此处为【基础库管理-课程管理】中的课程。选中您需要培训的课程然后点击表格中操作列的'下发任务'按钮及可根据这门指定的课程创建任务。选中需要培训的人员和考试即可完成任务创建<br/>
          下发来源是【商城】课程（或课程中包含来源商城的课件）需要根据平台设置的价格进行收费，学员每次点击进行学习将发起扣费。请保 <el-link @click="$router.push({
                    path: '/mall/flowingWater/recharge?clearTabNav=true'
                  });"  type="primary">账户余额</el-link>充足
        </el-alert>
      </div>

      <el-form style="margin-top: 20px" ref="form" :model="form" label-width="80px" @submit.native.prevent class="operationControl">
        <el-row>
            <el-col :span="6" class="pr20">
              <el-form-item label="课程名称" prop="trainingName">
                <el-input v-model="form.trainingName" @keyup.enter.native="search"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="pr20">
              <el-form-item label="培训类型" prop="trainingCategoryName">
                <el-input
                  clearable
                  @focus="showSelectTreeCategoryVisible"
                  ref="trainingCategoryInput"
                  @clear="trainingCategoryNameClear"
                  :disabled="$route.query.type == 'check'"
                  v-model="form.trainingCategoryName" clearable>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button type="primary" @click="search">搜索</el-button>
              </el-form-item>
            </el-col>
          </el-row>
      </el-form>
      <selectTrainingCategory ref="selectTrainingCategory"
                              @submit="selectTrainingCategorySubmitHandle"></selectTrainingCategory>
      <el-table height="540" :data="programList" style="width: 100%" v-loading="tableLoading"
                element-loading-text="拼命加载中">
        <el-table-column type="index" width="60" label="序号"></el-table-column>
        <el-table-column  width="280" prop="trainingName" label="课程名称"></el-table-column>
        <el-table-column width="100"
                         :show-overflow-tooltip="true">

          <template slot="header" slot-scope="scope">
            <span>来源</span>
            <el-tooltip class="item" effect="dark"  placement="top">
              <div slot="content" v-html="courseUtils.sourceTooltipExplain()"></div>
              <i class="el-icon-question"></i>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>

          <template slot-scope="scope">
            <span v-html="courseUtils.translateSourceName(scope.row)"></span>
          </template>
        </el-table-column>
        <el-table-column width="290" label="培训类型"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.trainingLevelName" v-html="scope.row.trainingLevelName">
            </span>
            <span v-else>
               --
            </span>
          </template>
        </el-table-column>
        <el-table-column label="行业类型"
                         :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.trainingIndustryName" v-html="scope.row.trainingIndustryName">
            </span>
            <span v-else>
               --
            </span>
          </template>
        </el-table-column>
        <el-table-column  width="150" prop="totalPrice" label="课程价格" v-if="config.includeMall && !config.freeCourse">
          <template slot="header" slot-scope="scope">
            <span>课程价格</span>
            <span>(元)</span>
            <!--            <el-tooltip class="item" effect="dark" content="  来源：-->
            <!--            商城：从商城加入课程；-->
            <!--            上传：企业自己上传课程；-->
            <!--            平台分配：由平台分发给企业的课程" placement="top">-->
            <!--              <i class="el-icon-question"></i>-->
            <!--            </el-tooltip>-->
          </template>

          <template slot-scope="scope" >
            <span v-if="scope.row.free" >
              限时免费
            </span>
            <span v-else>
               {{scope.row.totalPrice}}
            </span>
          </template>

        </el-table-column>

        <el-table-column label="操作"  width="100" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              @click="
                  $router.push(
                    '/trainingManagement/task/publishTask?id=' + scope.row.id
                  )
                ">下发任务</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        style="margin-top:20px; float:right;"
        @size-change="sizeChange"
        :current-page="page"
        @current-change="pageChange"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>

    </el-drawer>
</template>
<script>
import API from "../../../api/new/training.js";
import api from "../../../api/new/training";
import exam from "@/api/new/exam.js";
import selectTree from "@/components/common/selectTree";
import selectTrainingCategory from "@/components/training/selectTrainingCategory";
import config from '@/config/config.js'

import courseUtils from  '@/common/courseUtils.js'


export default {
  components: {selectTree, selectTrainingCategory},
  data() {
    return {
      config:config,
      courseUtils:  courseUtils,
      form: {
        trainingName: undefined, //培训内容
        principalName: undefined, //负责人名称
        trainingContent: undefined, //培训内容
        startCreatedTime: undefined, //制定开始时间
        endCreatedTime: undefined, //制定结束时间
        issuedStatus: undefined, //下发状态
        startIssuedTime: undefined, //下发开始时间
        endIssuedTime: undefined, //下发结束时间
        createdTime: [],
        issuedTime: [],
        directoryId: undefined,

        // training
        trainingLevelName: undefined,
        trainingIndustryName: undefined,
        trainingPostName: undefined,
        trainingTypeName: undefined,

        trainingCategoryName: undefined

      },
      programList: [],
      page: 1,
      pageSize: 10,
      total: 0,  // 总条数
      catalogList: [],   //目录列表
      tableLoading: false,
      visible: false
    };
  },
  mounted() {
    this.search();
    this.getCatalogList();
  },
  methods: {
    pageChange(e) {
      this.page = e;
      this.getProgramList();
    },
    sizeChange(e){
      this.pageSize = e;
      this.getProgramList();
    },
    search(){
      this.page = 1;
      this.getProgramList();
    },
    getProgramList() {
      let p = {...this.form, enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId,};
      p.page = this.page;
      p.pageSize = this.pageSize;

      delete p.trainingCategoryName;

      if (p.createdTime.length > 0) {
        p.startCreatedTime = p.createdTime[0];
        p.endCreatedTime = p.createdTime[1];
      }

      if (p.issuedTime.length > 0) {
        p.startIssuedTime = p.issuedTime[0];
        p.endIssuedTime = p.issuedTime[1];
      }
      delete p.createdTime;
      delete p.issuedTime;
      // pageSaftyList
      this.tableLoading = true;
      API.getPageProgramList(p).then(res => {
        this.programList = res.data.records;
        this.total = res.data.total;
        this.tableLoading = false;
      });
    },
    onSubmit() {
      console.log("submit!");
    },
    handleClick(row) {
      console.log(row);
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    delProgram(programId) {
      this.$confirm("此操作将删除该计划, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        API.delProgram({programId}).then(res => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getProgramList();
          } else {
            this.$message({
              type: "error",
              message: res.message
            });
          }
        });
      });
    },
    getCatalogList() {
      exam.getCatalogList({
        type: 4,
        enterpriseId: JSON.parse(localStorage.getItem("userinfo"))
          .enterpriseId
      })
        .then(res => {
          this.catalogList = res.data;
        });
    },
    selectTreeChange(v) {
      this.form.directoryId = e.id;
    },
    showSelectTreeCategoryVisible() {
      this.$refs.trainingCategoryInput.blur();
      this.$refs.selectTrainingCategory.showDialog();
    },
    selectTrainingCategorySubmitHandle(data) {
      this.form.trainingLevelName = data.trainingLevelName;
      this.form.trainingIndustryName = data.trainingIndustryName;
      this.form.trainingPostName = data.trainingPostName;
      this.form.trainingTypeName = data.trainingTypeName;
      this.form.trainingCategoryName = data.trainingCategoryName;
    },
    trainingCategoryNameClear() {
      this.form.trainingLevelName = undefined;
      this.form.trainingIndustryName = undefined;
      this.form.trainingPostName = undefined;
      this.form.trainingTypeName = undefined;
    },
    show(){
      this.search();
      this.visible =  true;
    }
  }
};
</script>

<style scoped>
.form {
  position: relative;
}

.searchBut {
  position: absolute;
  right: 0;
  top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/trainingManagement/task/selectCourse.vue